import { DataBean } from "../DataBean";

export class DocumentsForProjectData extends DataBean {



    public async getDocumentsForProjectData(tableName: any, idProject: any, idAccount: any, mnemonic: any, consecutive: any, accountantIDStr: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getDocumentsForProjectData_String_Number_Number_String_Number_String_String_Number_Number", [tableName, idProject, idAccount, mnemonic, consecutive, accountantIDStr, regexStr, page, recordsPerPage]);
    }

}